
import { AuthService } from "services/AuthService";
import { ReportService } from "services/ReportService";

const auth = new AuthService();
const reports = new ReportService()

export const gettingProfileCategory = async (
    setLoading: any,
    profileId: number,
    setSelected: any,
    setCategories: any
) => {
    try{
        setLoading(true);

        const profiles_permissions = await auth.permission.getProfilePermissions(profileId)
        setSelected(profiles_permissions.map(category => category.category_report_id));

        const body = {
            "columns_select":["*"],
            "where_select":"*"
        }
        const categories = await reports.category.getCategorys(body);
        setCategories(categories);
    }catch(error: any){
        console.error('Error fetching profiles:', error.message);
    }finally{
        setLoading(false);
    }
}

export const updatingProfileCategory = async (
    setLoading: any,
    profileId: number,
    selected: number[],
    closing: any,
) => {
    try{
        setLoading(true);
        const response = await auth.permission.assignProfileReportCategories(profileId, selected);
        console.log('response:', response);
        closing();
    }catch(error: any){
        console.error('Error fetching profiles:', error.message);
    }finally{
        setLoading(false);
    }
}